import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceRowType  {
    _originalTypeClassName = "zERP.BO.InvoiceRowType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceRowType.translate = translateService;
}
this.IncomeClassification = [];
this.ExpensesClassification = [];
this.ExpensesVATClassification = [];
this.IncomeVATClassification = [];
this.ExternalSystemInfo = [];
this.Id = null;
this.LineNumber = null;
this.Quantity = null;
this.MeasurementUnit = null;
this.InvoiceDetailType = null;
this.NetValue = null;
this.VatAmount = null;
this.GrossValue = null;
this.TotalDeductionsAmount = null;
this.GrossValuePlusDeductions = null;
this.DiscountOption = false;
this.WithheldAmount = null;
this.StampDutyAmount = null;
this.FeesAmount = null;
this.OtherTaxesAmount = null;
this.DeductionsAmount = null;
this.LineComments = null;
this.GetVatCategory = null;
this.GetVatExemptionCategory = null;
this.GetWithheldPercentCategory = null;
this.GetOtherTaxesPercentCategory = null;
this.GetStampDutyPercentCategory = null;
this.GetFeesPercentCategory = null;
this.GetRecType = null;
this.UntiCode = null;
this.UnitPrice = null;
this.UnitDescription = null;
this.RelatedInvoiceRowType = null;
this.ERPLIneAA = null;
this.LineType = null;
this.ERPAA = null;
this.ERPDocID = null;
this.RecTypeValue = null;
this.Expanded = false;
this.HasWithheldTax = false;
this.HasFeesTax = false;
this.HasOtherTax = false;
this.HasStampDuty = false;
this.HasDeductions = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
LineNumber:any;
Quantity:any;
MeasurementUnit:any;
InvoiceDetailType:any;
NetValue:any;
VatAmount:any;
GrossValue:any;
TotalDeductionsAmount:any;
GrossValuePlusDeductions:any;
DiscountOption:any;
WithheldAmount:any;
StampDutyAmount:any;
FeesAmount:any;
OtherTaxesAmount:any;
DeductionsAmount:any;
LineComments:any;
GetVatCategory:any;
GetVatExemptionCategory:any;
GetWithheldPercentCategory:any;
GetOtherTaxesPercentCategory:any;
GetStampDutyPercentCategory:any;
GetFeesPercentCategory:any;
GetRecType:any;
UntiCode:any;
UnitPrice:any;
UnitDescription:any;
RelatedInvoiceRowType:any;
ERPLIneAA:any;
LineType:any;
ERPAA:any;
ERPDocID:any;
RecTypeValue:any;
Expanded:any;
HasWithheldTax:any;
HasFeesTax:any;
HasOtherTax:any;
HasStampDuty:any;
HasDeductions:any;
SpendingRequestInvoicing:any;
Dienergia:any;
IncomeClassification:any;
ExpensesClassification:any;
ERPInvoiceType:any;
ERPInvoiceCategory:any;
WithheldPercentCategory:any;
StampDutyPercentCategory:any;
FeesPercentCategory:any;
OtherTaxesPercentCategory:any;
DeductionsPercentCategory:any;
ExpensesVATClassification:any;
IncomeVATClassification:any;
VatExemptionCategory:any;
VatCategory:any;
RowMetadata:any;
WithheldPaymentOrderDeductionDetail:any;
FeesPaymentOrderDeductionDetail:any;
OtherTaxesPaymentOrderDeductionDetail:any;
StampDutyPaymentOrderDeductionDetail:any;
DeductionsPaymentOrderDeductionDetail:any;
ExternalSystemInfo:any;
Note:any;
Good:any;
static setSpendingRequestInvoicing = ($this, value) => {
var oldValue = $this.SpendingRequestInvoicing;
$this.SpendingRequestInvoicing = value;
if (value != null) {
if (oldValue != null && oldValue.InvoiceRow != null) { oldValue.InvoiceRow = null; }
if ($this.SpendingRequestInvoicing.InvoiceRow !== $this) {
Domain.SpendingRequestInvoicing.setInvoiceRow(value, $this);
}
}
}
static setDienergia = ($this, value) => {
var oldValue = $this.Dienergia;
$this.Dienergia = value;
if (value != null) {
}
}
static setIncomeClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeClassification == null) $this.IncomeClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeClassification.length > 0) {
                    Domain.InvoiceRowType.removeIncomeClassification($this, $this.IncomeClassification[0]);
                }

                Domain.InvoiceRowType.addManyIncomeClassification($this, copyItems);
            }
static addManyIncomeClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceRowType.addIncomeClassification($this, items[i]);
                }
            }
static addIncomeClassification = ($this, item) => {
                if ($this.IncomeClassification == null) $this.IncomeClassification = [];
                if (item == null || $this.IncomeClassification.indexOf(item) > -1) return;
                $this.IncomeClassification.push(item);
}
static addRangeIncomeClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceRowType.addIncomeClassification($this, item));
            }
static removeIncomeClassification = ($this, item) => {
                if ($this == null || $this.IncomeClassification == null || $this.IncomeClassification.indexOf(item) === -1) return;
                var _index = $this.IncomeClassification.indexOf(item);
                $this.IncomeClassification.splice(_index, 1);
}
static clearIncomeClassification = ($this) => { $this.IncomeClassification = null; }
static setExpensesClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesClassification == null) $this.ExpensesClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesClassification.length > 0) {
                    Domain.InvoiceRowType.removeExpensesClassification($this, $this.ExpensesClassification[0]);
                }

                Domain.InvoiceRowType.addManyExpensesClassification($this, copyItems);
            }
static addManyExpensesClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceRowType.addExpensesClassification($this, items[i]);
                }
            }
static addExpensesClassification = ($this, item) => {
                if ($this.ExpensesClassification == null) $this.ExpensesClassification = [];
                if (item == null || $this.ExpensesClassification.indexOf(item) > -1) return;
                $this.ExpensesClassification.push(item);
}
static addRangeExpensesClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceRowType.addExpensesClassification($this, item));
            }
static removeExpensesClassification = ($this, item) => {
                if ($this == null || $this.ExpensesClassification == null || $this.ExpensesClassification.indexOf(item) === -1) return;
                var _index = $this.ExpensesClassification.indexOf(item);
                $this.ExpensesClassification.splice(_index, 1);
}
static clearExpensesClassification = ($this) => { $this.ExpensesClassification = null; }
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setWithheldPercentCategory = ($this, value) => {
var oldValue = $this.WithheldPercentCategory;
$this.WithheldPercentCategory = value;
if (value != null) {
}
}
static setStampDutyPercentCategory = ($this, value) => {
var oldValue = $this.StampDutyPercentCategory;
$this.StampDutyPercentCategory = value;
if (value != null) {
}
}
static setFeesPercentCategory = ($this, value) => {
var oldValue = $this.FeesPercentCategory;
$this.FeesPercentCategory = value;
if (value != null) {
}
}
static setOtherTaxesPercentCategory = ($this, value) => {
var oldValue = $this.OtherTaxesPercentCategory;
$this.OtherTaxesPercentCategory = value;
if (value != null) {
}
}
static setDeductionsPercentCategory = ($this, value) => {
var oldValue = $this.DeductionsPercentCategory;
$this.DeductionsPercentCategory = value;
if (value != null) {
}
}
static setExpensesVATClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesVATClassification == null) $this.ExpensesVATClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesVATClassification.length > 0) {
                    Domain.InvoiceRowType.removeExpensesVATClassification($this, $this.ExpensesVATClassification[0]);
                }

                Domain.InvoiceRowType.addManyExpensesVATClassification($this, copyItems);
            }
static addManyExpensesVATClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceRowType.addExpensesVATClassification($this, items[i]);
                }
            }
static addExpensesVATClassification = ($this, item) => {
                if ($this.ExpensesVATClassification == null) $this.ExpensesVATClassification = [];
                if (item == null || $this.ExpensesVATClassification.indexOf(item) > -1) return;
                $this.ExpensesVATClassification.push(item);
}
static addRangeExpensesVATClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceRowType.addExpensesVATClassification($this, item));
            }
static removeExpensesVATClassification = ($this, item) => {
                if ($this == null || $this.ExpensesVATClassification == null || $this.ExpensesVATClassification.indexOf(item) === -1) return;
                var _index = $this.ExpensesVATClassification.indexOf(item);
                $this.ExpensesVATClassification.splice(_index, 1);
}
static clearExpensesVATClassification = ($this) => { $this.ExpensesVATClassification = null; }
static setIncomeVATClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeVATClassification == null) $this.IncomeVATClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeVATClassification.length > 0) {
                    Domain.InvoiceRowType.removeIncomeVATClassification($this, $this.IncomeVATClassification[0]);
                }

                Domain.InvoiceRowType.addManyIncomeVATClassification($this, copyItems);
            }
static addManyIncomeVATClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceRowType.addIncomeVATClassification($this, items[i]);
                }
            }
static addIncomeVATClassification = ($this, item) => {
                if ($this.IncomeVATClassification == null) $this.IncomeVATClassification = [];
                if (item == null || $this.IncomeVATClassification.indexOf(item) > -1) return;
                $this.IncomeVATClassification.push(item);
}
static addRangeIncomeVATClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceRowType.addIncomeVATClassification($this, item));
            }
static removeIncomeVATClassification = ($this, item) => {
                if ($this == null || $this.IncomeVATClassification == null || $this.IncomeVATClassification.indexOf(item) === -1) return;
                var _index = $this.IncomeVATClassification.indexOf(item);
                $this.IncomeVATClassification.splice(_index, 1);
}
static clearIncomeVATClassification = ($this) => { $this.IncomeVATClassification = null; }
static setVatExemptionCategory = ($this, value) => {
var oldValue = $this.VatExemptionCategory;
$this.VatExemptionCategory = value;
if (value != null) {
}
}
static setVatCategory = ($this, value) => {
var oldValue = $this.VatCategory;
$this.VatCategory = value;
if (value != null) {
}
}
static setRowMetadata = ($this, value) => {
var oldValue = $this.RowMetadata;
$this.RowMetadata = value;
if (value != null) {
}
}
static setWithheldPaymentOrderDeductionDetail = ($this, value) => {
var oldValue = $this.WithheldPaymentOrderDeductionDetail;
$this.WithheldPaymentOrderDeductionDetail = value;
if (value != null) {
if (oldValue != null && oldValue.WithheldInvoiceDetail != null) { oldValue.WithheldInvoiceDetail = null; }
if ($this.WithheldPaymentOrderDeductionDetail.WithheldInvoiceDetail !== $this) {
Domain.PaymentOrderDeductionDetail.setWithheldInvoiceDetail(value, $this);
}
}
}
static setFeesPaymentOrderDeductionDetail = ($this, value) => {
var oldValue = $this.FeesPaymentOrderDeductionDetail;
$this.FeesPaymentOrderDeductionDetail = value;
if (value != null) {
if (oldValue != null && oldValue.FeesInvoiceDetail != null) { oldValue.FeesInvoiceDetail = null; }
if ($this.FeesPaymentOrderDeductionDetail.FeesInvoiceDetail !== $this) {
Domain.PaymentOrderDeductionDetail.setFeesInvoiceDetail(value, $this);
}
}
}
static setOtherTaxesPaymentOrderDeductionDetail = ($this, value) => {
var oldValue = $this.OtherTaxesPaymentOrderDeductionDetail;
$this.OtherTaxesPaymentOrderDeductionDetail = value;
if (value != null) {
if (oldValue != null && oldValue.OtherTaxesInvoiceDetail != null) { oldValue.OtherTaxesInvoiceDetail = null; }
if ($this.OtherTaxesPaymentOrderDeductionDetail.OtherTaxesInvoiceDetail !== $this) {
Domain.PaymentOrderDeductionDetail.setOtherTaxesInvoiceDetail(value, $this);
}
}
}
static setStampDutyPaymentOrderDeductionDetail = ($this, value) => {
var oldValue = $this.StampDutyPaymentOrderDeductionDetail;
$this.StampDutyPaymentOrderDeductionDetail = value;
if (value != null) {
if (oldValue != null && oldValue.StampDutyInvoiceDetail != null) { oldValue.StampDutyInvoiceDetail = null; }
if ($this.StampDutyPaymentOrderDeductionDetail.StampDutyInvoiceDetail !== $this) {
Domain.PaymentOrderDeductionDetail.setStampDutyInvoiceDetail(value, $this);
}
}
}
static setDeductionsPaymentOrderDeductionDetail = ($this, value) => {
var oldValue = $this.DeductionsPaymentOrderDeductionDetail;
$this.DeductionsPaymentOrderDeductionDetail = value;
if (value != null) {
if (oldValue != null && oldValue.DeductionsInvoiceDetail != null) { oldValue.DeductionsInvoiceDetail = null; }
if ($this.DeductionsPaymentOrderDeductionDetail.DeductionsInvoiceDetail !== $this) {
Domain.PaymentOrderDeductionDetail.setDeductionsInvoiceDetail(value, $this);
}
}
}
static setExternalSystemInfo = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExternalSystemInfo == null) $this.ExternalSystemInfo = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExternalSystemInfo.length > 0) {
                    Domain.InvoiceRowType.removeExternalSystemInfo($this, $this.ExternalSystemInfo[0]);
                }

                Domain.InvoiceRowType.addManyExternalSystemInfo($this, copyItems);
            }
static addManyExternalSystemInfo = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceRowType.addExternalSystemInfo($this, items[i]);
                }
            }
static addExternalSystemInfo = ($this, item) => {
                if ($this.ExternalSystemInfo == null) $this.ExternalSystemInfo = [];
                if (item == null || $this.ExternalSystemInfo.indexOf(item) > -1) return;
                $this.ExternalSystemInfo.push(item);
}
static addRangeExternalSystemInfo = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceRowType.addExternalSystemInfo($this, item));
            }
static removeExternalSystemInfo = ($this, item) => {
                if ($this == null || $this.ExternalSystemInfo == null || $this.ExternalSystemInfo.indexOf(item) === -1) return;
                var _index = $this.ExternalSystemInfo.indexOf(item);
                $this.ExternalSystemInfo.splice(_index, 1);
}
static clearExternalSystemInfo = ($this) => { $this.ExternalSystemInfo = null; }
static setNote = ($this, value) => {
var oldValue = $this.Note;
$this.Note = value;
if (value != null) {
}
}
static setGood = ($this, value) => {
var oldValue = $this.Good;
$this.Good = value;
if (value != null) {
}
}

static AutoFillExpensesClassificationAmount($this: any, classification: any): any{for (let _iexpensesClassificationType = 0; _iexpensesClassificationType < ($this?.ExpensesClassification == null ? 0 : $this?.ExpensesClassification.length); _iexpensesClassificationType++) {let expensesClassificationType = $this?.ExpensesClassification[_iexpensesClassificationType];if (CLMS.Framework.Number.GreaterThan(() => expensesClassificationType.Amount, () => $this.NetValue)) {expensesClassificationType.Amount = $this?.NetValue;}}
let existingAmount = $this?.ExpensesClassification?.linq?.where((c) => c != classification)?.toArray()?.linq?.sum((c) => c?.Amount);
let remainingAmount = Joove.Common.safeNumber($this?.NetValue) - Joove.Common.safeNumber(existingAmount);
if (CLMS.Framework.Number.LessThan(() => remainingAmount, () => 0)) {remainingAmount = 0;}
classification.Amount = remainingAmount;
}
static AutoFillIncomeClassificationAmount($this: any, classification: any): any{for (let _iincomeClassificationType = 0; _iincomeClassificationType < ($this?.IncomeClassification == null ? 0 : $this?.IncomeClassification.length); _iincomeClassificationType++) {let incomeClassificationType = $this?.IncomeClassification[_iincomeClassificationType];if (CLMS.Framework.Number.GreaterThan(() => incomeClassificationType.Amount, () => $this.NetValue)) {incomeClassificationType.Amount = $this?.NetValue;}}
let existingAmount = $this?.IncomeClassification?.linq?.where((c) => c != classification)?.toArray()?.linq?.sum((c) => c?.Amount);
let remainingAmount = Joove.Common.safeNumber($this?.NetValue) - Joove.Common.safeNumber(existingAmount);
if (CLMS.Framework.Number.LessThan(() => remainingAmount, () => 0)) {remainingAmount = 0;}
classification.Amount = remainingAmount;
}
static AutoFillVATExpensesClassificationAmount($this: any, classification: any): any{for (let _iexpensesClassificationType = 0; _iexpensesClassificationType < ($this?.ExpensesVATClassification == null ? 0 : $this?.ExpensesVATClassification.length); _iexpensesClassificationType++) {let expensesClassificationType = $this?.ExpensesVATClassification[_iexpensesClassificationType];if (CLMS.Framework.Number.GreaterThan(() => expensesClassificationType.Amount, () => $this.NetValue)) {expensesClassificationType.Amount = $this?.NetValue;}}
let existingAmount = $this?.ExpensesVATClassification?.linq?.where((c) => c != classification)?.toArray()?.linq?.sum((c) => c?.Amount);
let remainingAmount = Joove.Common.safeNumber($this?.NetValue) - Joove.Common.safeNumber(existingAmount);
if (CLMS.Framework.Number.LessThan(() => remainingAmount, () => 0)) {remainingAmount = 0;}
classification.Amount = remainingAmount;
}
static AutoFillVATIncomeClassificationAmount($this: any, classification: any): any{for (let _iincomeClassificationType = 0; _iincomeClassificationType < ($this?.IncomeVATClassification == null ? 0 : $this?.IncomeVATClassification.length); _iincomeClassificationType++) {let incomeClassificationType = $this?.IncomeVATClassification[_iincomeClassificationType];if (CLMS.Framework.Number.GreaterThan(() => incomeClassificationType.Amount, () => $this.NetValue)) {incomeClassificationType.Amount = $this?.NetValue;}}
let existingAmount = $this?.IncomeVATClassification?.linq?.where((c) => c != classification)?.toArray()?.linq?.sum((c) => c?.Amount);
let remainingAmount = Joove.Common.safeNumber($this?.NetValue) - Joove.Common.safeNumber(existingAmount);
if (CLMS.Framework.Number.LessThan(() => remainingAmount, () => 0)) {remainingAmount = 0;}
classification.Amount = remainingAmount;
}
static FillClassificationFromInvoiceType($this: any, invoiceTypeValueObject: any,transactionType: any): any{if (invoiceTypeValueObject == null) {return;}
let invoiceTransactionConfiguration = new Domain.InvoiceTransactionConfiguration();
switch (transactionType) {case Domain.TransactionType.Income:
{
invoiceTransactionConfiguration = invoiceTypeValueObject?.IncomeConfiguration;if (!(invoiceTransactionConfiguration?.Enabled)) {return;}let defaultInvoiceIncomeClassificationCategory = invoiceTransactionConfiguration?.SupportedIncomeClassifications?.linq?.where((c) => c?.IsDefault == true)?.firstOrDefault(null);if (defaultInvoiceIncomeClassificationCategory == null) {return;}let incomeClassificationType = new Domain.IncomeClassificationType();Domain.IncomeClassificationType.setClassificationCategory(incomeClassificationType, defaultInvoiceIncomeClassificationCategory?.Category);Domain.IncomeClassificationType.setClassificationType(incomeClassificationType, defaultInvoiceIncomeClassificationCategory?.Types?.linq?.where()?.firstOrDefault(null));$this?.IncomeClassification?.add(incomeClassificationType);break;}
case Domain.TransactionType.Expense:
{
invoiceTransactionConfiguration = invoiceTypeValueObject?.ExpensesConfiguration;if (!(invoiceTransactionConfiguration?.Enabled)) {return;}let defaultInvoiceExpensesClassificationCategory = invoiceTransactionConfiguration?.SupportedExpensesClassifications?.linq?.where((c) => c?.IsDefault)?.firstOrDefault(null);if (defaultInvoiceExpensesClassificationCategory == null) {return;}let expensesClassificationType = new Domain.ExpensesClassificationType();Domain.ExpensesClassificationType.setClassificationCategory(expensesClassificationType, defaultInvoiceExpensesClassificationCategory?.Category);Domain.ExpensesClassificationType.setClassificationType(expensesClassificationType, defaultInvoiceExpensesClassificationCategory?.Types?.linq?.where()?.firstOrDefault(null));$this?.ExpensesClassification?.add(expensesClassificationType);break;}
case Domain.TransactionType.Accounting:
{
invoiceTransactionConfiguration = invoiceTypeValueObject?.AccountingConfiguration;break;}
}
}
static FillSpecified($this: any): any{}
static GetAmountForBudgetTransaction($this: any, taxesPerInvoiceLine: any,forceUseGrossValue: any,configuration: any): any{let useGrossAmount = configuration?.UseGrossAmountOnBudget || forceUseGrossValue;
if (useGrossAmount) {return (!(taxesPerInvoiceLine) ? $this?.GrossValue : $this?.GrossValuePlusDeductions);}
return $this?.NetValue;
}
static GetDeductionsAmount($this: any): any{let amount = 0;
if ($this?.WithheldPercentCategory != null && !($this?.WithheldPercentCategory?.IsPrepaid) && CLMS.Framework.Number.NotEqual(() => $this.WithheldPercentCategory.Amount, () => null)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.WithheldAmount);}
if ($this?.DeductionsPercentCategory != null && !($this?.DeductionsPercentCategory?.IsPrepaid) && CLMS.Framework.Number.GreaterThan(() => $this.DeductionsAmount, () => 0)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.DeductionsAmount);}
return amount;
}
static GetGrossValue($this: any): any{let amount = Joove.Common.safeNumber($this?.NetValue) + Joove.Common.safeNumber($this?.VatAmount);
if ($this?.WithheldPercentCategory != null && !($this?.WithheldPercentCategory?.IsPrepaid) && CLMS.Framework.Number.NotEqual(() => $this.WithheldPercentCategory.Amount, () => null)) {amount = Joove.Common.safeNumber(amount) - Joove.Common.safeNumber($this?.WithheldAmount);}
if ($this?.DeductionsPercentCategory != null && !($this?.DeductionsPercentCategory?.IsPrepaid) && CLMS.Framework.Number.NotEqual(() => $this.DeductionsPercentCategory.Amount, () => null)) {amount = Joove.Common.safeNumber(amount) - Joove.Common.safeNumber($this?.DeductionsAmount);}
if ($this?.OtherTaxesPercentCategory != null && CLMS.Framework.Number.NotEqual(() => $this.OtherTaxesPercentCategory.Amount, () => null)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.OtherTaxesAmount);}
if ($this?.StampDutyPercentCategory != null && CLMS.Framework.Number.NotEqual(() => $this.StampDutyPercentCategory.Amount, () => null)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.StampDutyAmount);}
if ($this?.FeesPercentCategory != null && CLMS.Framework.Number.NotEqual(() => $this.FeesPercentCategory.Amount, () => null)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.FeesAmount);}
return amount;
}
static GetGrossValuePlusDeductions($this: any): any{return Joove.Common.safeNumber($this?.GrossValue) + Joove.Common.safeNumber($this?.TotalDeductionsAmount);
}
static GetTaxesAmount($this: any): any{let amount = 0;
if ($this?.StampDutyPercentCategory != null && CLMS.Framework.Number.GreaterThan(() => $this.StampDutyAmount, () => 0)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.StampDutyAmount);}
if ($this?.OtherTaxesPercentCategory != null && CLMS.Framework.Number.GreaterThan(() => $this.OtherTaxesAmount, () => 0)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.OtherTaxesAmount);}
if ($this?.FeesPercentCategory != null && CLMS.Framework.Number.GreaterThan(() => $this.FeesAmount, () => 0)) {amount = Joove.Common.safeNumber(amount) + Joove.Common.safeNumber($this?.FeesAmount);}
return amount;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}